import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { QuestionSegmentProps } from '@/views/process/components/quizInialized/questions/QuestionSegment.model.ts';
import QuestionWrapper from '@/views/process/components/quizInialized/questions/QuestionWrapper.tsx';
import { FC } from 'react';

const audioUrl = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_3.mp3';
const animationUrl = 'https://lets-orange.b-cdn.net/animacje/LOQ_S1_A_02.json';

const QuestionSegment1: FC<QuestionSegmentProps> = ({ formComponent }) => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions');

  return (
    <QuestionWrapper
      animationUrl={animationUrl}
      audioUrl={audioUrl}
      formComponent={formComponent}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.1.titles.1')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.1.content.1')}</p>
            <p className="lead">{t('questions.1.content.2')}</p>
            <p className="lead">{t('questions.1.content.3')}</p>
            <p className="lead">{t('questions.1.content.4')}</p>
          </div>
        </>
      }
    />
  );
};

export default QuestionSegment1;
